import { useEffect } from "react";
import { BackButtonEvent } from "@ionic/core/components";
import { useIonRouter } from "@ionic/react";
import { App } from "@capacitor/app";
import { useHistory } from "react-router";
import { Capacitor } from "@capacitor/core";
import { useConfig } from "../providers/config";

export const useBackButton = () => {
  const router = useIonRouter();
  const history = useHistory();
  const config = useConfig();

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const handleBackButton = (ev: BackButtonEvent) => {
        ev.detail.register(100, () => {
          if (!router.canGoBack()) {
            config.exitAppICantGoBack && App.exitApp();
          } else {
            history.goBack();
          }
        });
      };

      document.addEventListener("ionBackButton", handleBackButton as EventListener);

      return () => {
        document.removeEventListener("ionBackButton", handleBackButton as EventListener);
      };
    }
  }, [router, history, config.exitAppICantGoBack]);
};
